import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stakeholderTypes: [],
};

const stkSlice = createSlice({
  name: "stk",
  initialState,
  reducers: {
    setStakeholderTypes: (state, action) => {
      return { ...state, stakeholderTypes: action.payload };
    },
  },
});

export const stkActions = stkSlice.actions;
export default stkSlice;
